import './RegistrationInfo.less';
import React from 'react';
import { getStyleOverride } from '../util/config';

function ArcPage({ children }) {
    return (
        <div className="registration-info" style={getStyleOverride('registration-info')}>
            {children}
        </div>
    );
}

ArcPage.Top = function({ children }) {
    return (
        <div className="registration-info-header">
            <div className="registration-info-in">{children}</div>
        </div>
    );
};
ArcPage.Body = function({ children }) {
    return (
        <div className="registration-info-content">
            <div className="registration-info-in">{children}</div>
        </div>
    );
};

export default ArcPage;
